import { defineComponent as _defineComponent } from 'vue';
import { createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = { class: "left-filter-section" };
const _hoisted_2 = { class: "right-filter-section" };
import SubControllerTemplate from '@/templates/SubControllerTemplate.vue';
import { computed, onMounted, ref, watch, } from 'vue';
import { pageSizeOptionList } from '@/constants';
import { searchFieldTypeOptions, workerStatusOptions, workerStatusTypeData, } from '@/constants/workerManagementList';
import SearchInput from '@/components/Form/SearchInput.vue';
import Select from '@/components/Form/Select.vue';
import SearchInputWrapper from '@/components/Form/SearchInputWrapper.vue';
import vuexStore from '@/vuex-store';
import { useRoute, useRouter, } from 'vue-router';
import { hubSelectorGetterType } from '@/vuex-store/hub-selector/getters';
import { pageSizeEnum } from '@/constants/pageSizeOptionList';
const lc = 'views.worker_management_list.';
export default /*@__PURE__*/ _defineComponent({
    __name: 'SubController',
    setup(__props) {
        const route = useRoute();
        const router = useRouter();
        const isInitialize = ref(false);
        const searchFieldType = ref(searchFieldTypeOptions[0].value);
        const searchValue = ref('');
        const filteredWorkerStatusOptionList = ref([]); // 상태 셀렉트옵션
        const workerStatus = ref('');
        const pageSizeType = ref(pageSizeOptionList[0].value); // 선택된 검색어 셀렉트옵션
        const getterSubscribeHubId = computed(() => vuexStore.getters[hubSelectorGetterType.getterSubscribeHubId]);
        const filterOption = computed(() => vuexStore.state.workerManagement.workerList.filterOption);
        const sortOption = computed(() => vuexStore.state.workerManagement.workerList.sortOption);
        const getterSearchValue = computed(() => vuexStore.getters['workerManagement/workerList/getterSearchValue']);
        const setFilterOption = async (filterData) => {
            await vuexStore.dispatch('workerManagement/workerList/setFilterOption', filterData);
        };
        const getWorkerList = async () => {
            await vuexStore.dispatch('workerManagement/workerList/getWorkerList');
        };
        /**
         * 검색유형 핸들러
         */
        const handleChangeSearchFieldType = (selectedType) => {
            searchFieldType.value = selectedType;
        };
        /**
         * 검색 핸들러
         */
        const handleSearch = async (value) => {
            await setFilterOption({
                searchWord: {
                    field: searchFieldType.value,
                    value,
                },
            });
            const { query } = route;
            router.replace({
                query: {
                    ...query,
                    searchField: searchFieldType.value,
                    searchValue: value,
                },
            }).catch(() => { });
        };
        /**
         * 셀렉터 변경 핸들러
         */
        const handleChangeSelect = (selectType) => (selectOptionValue) => {
            if (!selectOptionValue) {
                return;
            }
            const { query } = route;
            const replaceParam = {
                query: {
                    ...query,
                    [selectType]: selectOptionValue,
                },
            };
            router.replace(replaceParam);
            const filterData = {
                [selectType]: selectOptionValue,
            };
            if (selectType === 'pageSizeType') {
                filterData.pageNumber = '1';
            }
            setFilterOption(filterData);
        };
        const init = async () => {
            // 필터 초기셋팅
            searchFieldType.value = (route?.query?.searchField || searchFieldTypeOptions[0].value);
            searchValue.value = (route?.query?.searchValue || '');
            workerStatus.value = (route?.query?.workerStatus || workerStatusTypeData.OK.value);
            filteredWorkerStatusOptionList.value = workerStatusOptions
                .filter((key) => key.value !== 'DELETE');
            pageSizeType.value = pageSizeEnum['50'];
            const { searchField: searchFieldQuery, searchValue: searchValueQuery, workerStatus: workerStatusQuery, pageSizeType: pageSizeTypeQuery, } = route.query;
            if (searchFieldQuery) {
                searchFieldType.value = searchFieldQuery;
                searchValue.value = searchValueQuery;
                workerStatus.value = workerStatusQuery;
                pageSizeType.value = pageSizeTypeQuery ?? pageSizeType.value;
            }
            // 초기셋팅
            if (isInitialize.value) {
                router.replace({
                    query: {
                        searchField: searchFieldType.value,
                        searchValue: searchValue.value,
                        workerStatus: workerStatus.value,
                        pageSizeType: pageSizeType.value,
                    },
                }).catch(() => { });
            }
            await setFilterOption({
                searchWord: {
                    field: searchFieldType.value,
                    value: searchValue.value,
                },
                workerStatus: workerStatus.value,
                pageSizeType: pageSizeType.value,
            });
            if (!getterSubscribeHubId.value) {
                isInitialize.value = false;
                return;
            }
            // 액션 호출
            getWorkerList();
            isInitialize.value = false;
        };
        onMounted(async () => {
            isInitialize.value = true;
            await init();
        });
        watch(() => filterOption.value, () => {
            if (!getterSubscribeHubId.value) {
                return;
            }
            if (!isInitialize.value) {
                getWorkerList();
            }
        }, {
            deep: true,
        });
        watch(() => getterSubscribeHubId.value, () => {
            if (!isInitialize.value) {
                const firstPageNumber = 1;
                setFilterOption({
                    pageNumber: firstPageNumber,
                });
                getWorkerList();
            }
        });
        watch(() => sortOption.value, () => {
            if (!getterSubscribeHubId.value) {
                return;
            }
            if (!isInitialize.value) {
                getWorkerList();
            }
        }, {
            deep: true,
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(SubControllerTemplate, null, {
                toolsSlot: _withCtx(() => [
                    _createElementVNode("div", _hoisted_1, [
                        _createCommentVNode(" 상태 "),
                        _createVNode(Select, {
                            width: 100,
                            value: filterOption.value?.workerStatus,
                            title: _ctx.$t(`${lc}status`),
                            items: filteredWorkerStatusOptionList.value,
                            "on-change": handleChangeSelect('workerStatus')
                        }, null, 8 /* PROPS */, ["value", "title", "items", "on-change"])
                    ]),
                    _createElementVNode("div", _hoisted_2, [
                        _createCommentVNode(" 검색 "),
                        _createVNode(SearchInputWrapper, null, {
                            default: _withCtx(() => [
                                _createVNode(Select, {
                                    width: 110,
                                    value: searchFieldType.value,
                                    items: _unref(searchFieldTypeOptions),
                                    "on-change": handleChangeSearchFieldType
                                }, null, 8 /* PROPS */, ["value", "items"]),
                                _createVNode(SearchInput, {
                                    outlined: "",
                                    placeholder: _ctx.$t('common.input_field_placeholder', { field: _ctx.$t(`common.search_word`) }),
                                    "on-search": handleSearch,
                                    "default-value": getterSearchValue.value
                                }, null, 8 /* PROPS */, ["placeholder", "default-value"])
                            ]),
                            _: 1 /* STABLE */
                        })
                    ])
                ]),
                _: 1 /* STABLE */
            }));
        };
    }
});
